// extracted by mini-css-extract-plugin
export default {"base":"DownloadReportPage_base__pP+2L","content":"DownloadReportPage_content__C2MSE","subtitle":"DownloadReportPage_subtitle__zW2wK"};